import React from 'react';
import { Button } from '@saviynt/design-system';
import { format } from 'sql-formatter';

import './ContentNotAccurate.css';

interface ContentNotAccurateProps {
  panelHeader?: React.ReactElement;
  toggleSelection?: number;
  query?: string;
  onClick?: () => void;
}

ContentNotAccurate.defaultProps = {
  panelHeader: <div />,
  toggleSelection: 1,
  query: 'default query',
  onClick: () => {},
};

function ContentNotAccurate({
  panelHeader,
  toggleSelection,
  query,
  onClick,
}: ContentNotAccurateProps): JSX.Element {
  const formattedQuery = format(query ?? '');

  return (
    <section className='Ispm-ContentNotAccurate'>
      <div className='Ispm-CantBeDisplayed-lowConfidence'>{panelHeader}</div>
      {toggleSelection === 1 ? (
        <div className='Ispm-ContentNotAccurate-contentWrapper'>
          <div className='Ispm-ContentNotAccurate-contentWrapper-text'>
            <div className='Ispm-ContentNotAccurate-contentWrapper-text-primary'>
              Content May Be Inaccurate
            </div>
            <div className='Ispm-ContentNotAccurate-contentWrapper-text-secondary'>
              The generated content may have errors or may not show at all. Do
              you still want to view it?
            </div>
          </div>
          <div className='Ispm-GeneratingContent-contentWrapper-button'>
            <Button size='medium' kind='filled' onClick={onClick}>
              Show Anyway
            </Button>
          </div>
        </div>
      ) : (
        <div className='Ispm-ContentNotAccurate-lowConfidence-sql'>
          <pre className='Ispm-ContentNotAccurate-lowConfidence-sql-content'>
            <code>{formattedQuery}</code>
          </pre>
        </div>
      )}
    </section>
  );
}

export default ContentNotAccurate;
